<template lang="pug">
.FcwBanner(
  v-if="text.trim()"
  :style="style"
  :class="classes"
)
  FIcon(
    :name="icon"
    :size="fontSize === 'large' ? 32 : 24"
    :color="iconColor"
  )
  .FcwBanner__text
    span {{ text }}
    slot
</template>

<style lang="stylus">
.FcwBanner
  display flex
  align-items center
  background-color var(--FcwBanner--backgroundColor)
  border-radius rem(8)
  padding rem(16)

  .FIcon
    margin-right rem(8)

.FcwBanner__text
  display flex
  align-items flex-start
  flex-direction column
  gap 0.25rem

  span
    margin-right rem(16)
    use-font('caption')
    font-weight 400
    color var(--color--neutral--dark-4)
    white-space pre-line

  &--large
    span
      use-font('body-2')
</style>

<script setup lang="ts">
export interface FcwBannerProps {
  /**
   * Icon of the banner
   */
  icon?: Icon;
  /**
   * Color of the banner
   */
  color?: Color;
  /**
   * Text of the banner
   */
  text?: string;
  /**
   * Font size
   */
  fontSize?: 'normal' | 'large';
}

const props = withDefaults(defineProps<FcwBannerProps>(), {
  icon: 'infoCircle',
  color: 'info',
  text: ' ',
  fontSize: 'normal',
});

const iconColor = computed(() =>
  props.color === 'neutral'
    ? `${props.color}--dark-4`
    : `${props.color}--dark-2`
);

const classes = computed<Style>(() => ({
  'FcwBanner__text--large': props.fontSize === 'large',
}));

const style = computed<Style>(() => ({
  '--FcwBanner--backgroundColor': getCssColor(
    props.color === 'neutral'
      ? `${props.color}--light-4`
      : `${props.color}--light-2`
  ),
}));
</script>
